import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import getRemBase from 'propel/getRemBase';

const sliders = document.querySelectorAll(
	'.block-testimonial-carousel .swiper'
);

const setSlideScale = (block, placeholder, swiper) => {
	let offsetModifier = 40;

	if (document.body.clientWidth >= 768) {
		offsetModifier = 280;
	}

	block.style.setProperty(
		'--slideScale',
		(placeholder.offsetWidth - offsetModifier) / placeholder.offsetWidth
	);

	if (swiper) {
		const currentSlide = swiper.slides[swiper.activeIndex];

		if (currentSlide) {
			block.style.setProperty(
				'--buttonPosition',
				`${currentSlide.getBoundingClientRect().left / getRemBase()}rem`
			);
		}
	}
};

const setCurrentSlideClass = (swiper) => {
	swiper.slides.forEach((slide) => {
		slide.classList.remove('swiper-slide-current');
	});

	const currentSlide = swiper.slides[swiper.activeIndex];

	if (currentSlide) {
		currentSlide.classList.add('swiper-slide-current');
	}
};

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const block = slider.closest('.block-testimonial-carousel');
		const slides = slider.querySelectorAll('.swiper-slide');
		const placeholder = block.querySelector(
			'.block-testimonial-carousel__placeholder'
		);
		const prevEl = slider.parentElement.querySelector(
			'.swiper-button-prev'
		);
		const nextEl = slider.parentElement.querySelector(
			'.swiper-button-next'
		);

		setSlideScale(block, placeholder);

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: -16,
			slidesPerView: document.body.clientWidth / placeholder.offsetWidth,
			centeredSlides: true,
			speed: 600,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl,
				nextEl,
			},
			on: {
				beforeResize(swiper) {
					swiper.params.slidesPerView =
						document.body.clientWidth / placeholder.offsetWidth;

					setSlideScale(block, placeholder, swiper);
				},
				init(swiper) {
					setCurrentSlideClass(swiper);
					setTimeout(() => {
						slider.classList.add('swiper-loaded');
					}, 10);
				},
				slideChangeTransitionEnd(swiper) {
					setCurrentSlideClass(swiper);
				},
			},
			breakpoints: {
				768: {
					spaceBetween: -140,
				},
			},
		};

		const swiperInstance = new Swiper(slider, settings);

		setSlideScale(block, placeholder, swiperInstance);
	});
}
